/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function () {
  $(".dp_tab__link").click(function (e) {
    e.preventDefault();
    $(".dp_tab__link").removeClass("dp_tab__link_active");
    $(this).addClass("dp_tab__link_active");
    $(".dp_tab__content").removeClass("dp_tab__content_active").hide();
    $($(this).data("target")).addClass("dp_tab__content_active").show();
  });
  $(".dp_tab__link").first().trigger("click");
});

$(document).ready(function () {
  setTimeout(() => {
    $(".rc_widget__option__input--subsave").click();
    console.log("called");
  }, 7000);

  $(".add_to_cart_coll").click(function () {
    var ID = $(this).attr("data-var_id");
    addItemToCart(ID, 1); // paste your id product number
    $(".cart_dr").trigger("click");
  });
  function addItemToCart(variant_id, qty) {
    // let cartDrawer = $("#sidebar-cart")
    data = {
      id: variant_id,
      quantity: qty,
    };
    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      success: function () {
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: true, //this code is for prestige theme, is to refresh the cart
          })
        );
      },
    });
  }
});
$(document).ready(function () {
  var $slider = $(".testimonial_slider");

  $slider.slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    speed: 400,
    dots: true,
    counter: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
});

$(document).ready(function () {
  var $featureCollectionSlider = $(".featureCollectionSlider");
  var $progressBar = $("#featureCollectionSliderProgress");
  var $progressBarLabel = $("#featureCollectionSliderProgress .slider__label");

  $featureCollectionSlider.on(
    "beforeChange",
    function (event, slick, currentSlide, nextSlide) {
      var calc = (nextSlide / (slick.slideCount - 1)) * 100;

      $progressBar
        .css("background-size", calc + "% 100%")
        .attr("aria-valuenow", calc);

      $progressBarLabel.text(calc + "% completed");
    }
  );

  $featureCollectionSlider.slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    speed: 300,
    dots: false,
    counter: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
});

$(document).ready(function () {
  var $shopByConcernSlider = $(".shopByConcernSlider");
  var $progressBar = $("#shopByConcernSliderProgress");
  var $progressBarLabel = $("#shopByConcernSliderProgress .slider__label");

  $shopByConcernSlider.on(
    "beforeChange",
    function (event, slick, currentSlide, nextSlide) {
      var calc = (nextSlide / (slick.slideCount - 1)) * 100;

      $progressBar
        .css("background-size", calc + "% 100%")
        .attr("aria-valuenow", calc);

      $progressBarLabel.text(calc + "% completed");
    }
  );

  $shopByConcernSlider.slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    speed: 300,
    dots: false,
    counter: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
});

$(document).ready(function () {
  $(".slider-content").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: false,
    infinite: false,
    speed: 1000,
    asNavFor: ".slider-thumb",
    arrows: true,
    prevArrow:
      '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button"></button>',
    nextArrow:
      '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button"></button>',
  });
  $(".slider-thumb").slick({
    slidesToShow: 3,
    asNavFor: ".slider-content",
    dots: false,
    focusOnSelect: true,
  });
});

$(document).ready(function () {
  $('.AnnouncementBar_slide').slick({
    arrows: false,
    centerPadding: "0px",
    dots: false,
    autoplay: true,
    slidesToShow: 1,
    infinite: true
  });
});
